var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input-number',{staticStyle:{"width":"64px"},attrs:{"size":"mini","step":1,"min":0,"precision":0,"controls":false},model:{value:(_vm.qty),callback:function ($$v) {_vm.qty=$$v},expression:"qty"}})}
var staticRenderFns = []

export { render, staticRenderFns }